import { useParams } from 'react-router-dom';
import { useEmployeeUrl } from 'domain/shared/employee';
import { useEntityUrl } from 'framework/routing';

const EMPLOYEE_CONTRACTS_ID_SOURCE = 'contractId';

export const useEmployeeContractUrl = () => {
  const { getSingleEntityUrl } = useEmployeeUrl();

  return useEntityUrl({ baseLink: `${getSingleEntityUrl()}/contracts` });
};

export const useEmployeeContractId = () => useParams<Dictionary<string>>()[EMPLOYEE_CONTRACTS_ID_SOURCE]!;
